module.exports = __webpack_public_path__ + "static/Forager6-68a3eaee553678da09fb2d2f6f622729.webp";